import { render, staticRenderFns } from "./newHelpDetail.vue?vue&type=template&id=3be838a2&scoped=true"
import script from "./newHelpDetail.vue?vue&type=script&lang=js"
export * from "./newHelpDetail.vue?vue&type=script&lang=js"
import style0 from "./newHelpDetail.vue?vue&type=style&index=0&id=3be838a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be838a2",
  null
  
)

export default component.exports